import { render } from "./BrandApartHotels.vue?vue&type=template&id=383e548d"
import script from "./BrandApartHotels.vue?vue&type=script&lang=js"
export * from "./BrandApartHotels.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__